import React, { useState } from "react";
import { Input } from "antd";

import "./style.css";

const { Search } = Input;

const SearchInput = ({
  placeholder,
  size,
  btnText,
  onChange,
  onSearch,
  loading,
  ...props
}) => {
  return (
    <Search
      placeholder={placeholder}
      allowClear
      enterButton={btnText || "Search"}
      size={size || "large"}
      onSearch={onSearch}
      onChange={onChange}
      loading={loading}
      {...props}
    />
  );
};

export default SearchInput;
